import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GameManager from './components/GameManager';
import { ScoreCleanup } from './components/ScoreCleanup';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import AboutUsPage from './components/AboutUsPage';
import ContactUsPage from './components/ContactUsPage';

function App() {
  return (
    <Router>
      <div className="App relative">
        <div className="min-h-screen mx-auto">
          <Routes>
            <Route path="/challenge/:date" element={<GameManager />} />
            <Route path="/" element={<GameManager />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactUsPage />} />

            {/* Optional cleanup route */}
            <Route path="/cleanup" element={<ScoreCleanup />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
